import React, { createContext, useContext, useState, useCallback } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const StripeContext = createContext();

const stripePromise = loadStripe(import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY);

export const StripeProvider = ({ children }) => {
  const [paymentAmount, setPaymentAmount] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);

  const getStripeOptions = useCallback((amount = null, currency = 'usd', secret = null) => {
    const options = {
      appearance: {
        theme: 'stripe',
        variables: {
          colorPrimary: '#0570de',
          colorBackground: '#ffffff',
          colorText: '#30313d',
          colorDanger: '#df1b41',
          fontFamily: 'Inter, system-ui, sans-serif',
          spacingUnit: '4px',
          borderRadius: '8px',
        }
      },
      mode: 'payment',
      currency: currency
    };

    // Add amount if provided (convert to cents for Stripe)
    if (amount && typeof amount === 'number' && amount > 0) {
      options.amount = Math.round(amount * 100);
    }

    // Add client secret if provided
    if (secret) {
      options.clientSecret = secret;
    }

    return options;
  }, []);

  const updatePaymentDetails = useCallback((amount, secret) => {
    setPaymentAmount(amount);
    setClientSecret(secret);
  }, []);

  const contextValue = {
    stripePromise,
    getStripeOptions,
    updatePaymentDetails,
    paymentAmount,
    clientSecret
  };

  return (
    <StripeContext.Provider value={contextValue}>
      {children}
    </StripeContext.Provider>
  );
};

export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripeContext must be used within a StripeProvider');
  }
  return context;
};

export default StripeContext;